import type { PromptCategory } from "@1js/pl-types";
import {
  ArrowSyncCheckmarkRegular,
  ArrowTrendingLinesRegular,
  CalendarClockRegular,
  CalendarEditRegular,
  CatchUpRegular,
  ChatBubblesQuestionRegular,
  ChatHelpRegular,
  CodeTextRegular,
  CollectionsRegular,
  DesignIdeasRegular,
  DocumentRegular,
  DraftsRegular,
  EditRegular,
  HatGraduationRegular,
  LightbulbRegular,
  Microscope20Regular,
  NewsRegular,
  PersonNoteRegular,
  PersonRegular,
  SearchRegular,
  SignatureRegular,
  TextBulletListSquareRegular,
  WrenchScrewdriverRegular,
} from "@fluentui/react-icons";
import React from "react";
import type { Appearance } from "../../data";
import { useStyles } from "./PromptIcon.styles";

export type PromptIconProps = {
  displayCategory: PromptCategory;
  appearance?: Appearance;
  isUserPrompt?: boolean;
};

export const displayCategoryToIcon = (
  displayCategory: PromptCategory,
  styles: Record<"icon", string>
) => {
  switch (displayCategory) {
    case "Create":
    case "Suggestion":
    case "Brainstorm":
      return <DraftsRegular className={styles.icon} />;
    case "Email":
      return <CatchUpRegular className={styles.icon} />;
    case "Edit":
      return <EditRegular className={styles.icon} />;
    case "Code":
      return <CodeTextRegular className={styles.icon} />;
    case "Analyze":
      return <Microscope20Regular className={styles.icon} />;
    case "Assist":
      return <ChatHelpRegular className={styles.icon} />;
    case "Automate":
      //todo: replace with automate icon
      return <></>;
    case "Browse":
      return <DocumentRegular className={styles.icon} />;
    case "Collect":
      return <CollectionsRegular className={styles.icon} />;
    case "Find":
      return <SearchRegular className={styles.icon} />;
    case "News":
      return <NewsRegular className={styles.icon} />;
    case "People":
      return <PersonRegular className={styles.icon} />;
    case "Prepare":
    case "Catch up":
    case "Summarize":
      return <TextBulletListSquareRegular className={styles.icon} />;
    case "Ask":
      return <ChatBubblesQuestionRegular className={styles.icon} />;
    case "Understand":
      return <LightbulbRegular className={styles.icon} />;
    case "UserAuthored":
    case "Created by Me":
      return <SignatureRegular className={styles.icon} />;
    case "Customize":
      return <PersonNoteRegular className={styles.icon} />;
    case "Design":
      return <DesignIdeasRegular className={styles.icon} />;
    case "Optimize":
      return <ArrowTrendingLinesRegular className={styles.icon} />;
    case "Operate":
      return <ArrowSyncCheckmarkRegular className={styles.icon} />;
    case "Troubleshoot":
      return <WrenchScrewdriverRegular className={styles.icon} />;
    case "Learn":
      return <HatGraduationRegular className={styles.icon} />;
    case "Schedule":
      return <CalendarClockRegular className={styles.icon} />;
    case "Manage":
      return <CalendarEditRegular className={styles.icon} />;
    default:
      return <></>;
  }
};

export const PromptIcon: React.FC<PromptIconProps> = ({
  displayCategory,
  appearance,
  isUserPrompt,
}) => {
  const styles = useStyles(appearance)();
  const displayCategoryToUse = isUserPrompt ? "Created by Me" : displayCategory;
  return (
    <span data-testid="prompt-icon">
      {displayCategoryToIcon(displayCategoryToUse, styles)}
    </span>
  );
};
